import { useTheme } from '@mui/material'
import { ItemTypesQuery, SelectItem } from '@kistill/client/data-access'
import { AutocompleteElement } from 'react-hook-form-mui'

interface ItemTypeChipProps {
  data: ItemTypesQuery | undefined
}

export function ItemTypeChip({ data }: ItemTypeChipProps) {
  const theme = useTheme()

  const options = data?.itemTypes?.map((x) => {
    return { guid: x.guid, label: x.name } as unknown as SelectItem
  })

  return (
    <AutocompleteElement
      multiple
      label='Tegund'
      name='itemType'
      options={options ?? []}
      textFieldProps={{
        sx: {
          backgroundColor: theme.palette.background.paper,
        },
      }}
      autocompleteProps={{
        size: 'small',
      }}
    />
  )
}
export default ItemTypeChip
